import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateInvoiceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 2.39941V7.39941H20.5",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 10.3994V6.39941C4.5 4.19028 6.29086 2.39941 8.5 2.39941H15.5L20.5 7.39941V18.3994C20.5 20.6086 18.7091 22.3994 16.5 22.3994H15.5",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.8335 13.3994V22.0661",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1665 17.7324L3.49984 17.7324",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})
	]
});
export default SvgCreateInvoiceIcon;
